import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GetTransactionDetails } from "../../Services/InsuranceApi";

const InsPrintInvoice = () => {
  const location = useLocation();

  const [data, setData] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  function getParamIgnoreCase(key) {
    for (const [k, v] of queryParams.entries()) {
      if (k.toLowerCase() === key.toLowerCase()) {
        return v;
      }
    }
    return null;
  }
  const referenceNo = getParamIgnoreCase("ReferenceNo");
  const key = getParamIgnoreCase("key");
  const clientCode = getParamIgnoreCase("clientCode");

  useEffect(() => {
    if (referenceNo && key && clientCode) {
      fetchData();
    }
  }, [referenceNo, key, clientCode]);

  const fetchData = async () => {
    try {
      const params = {
        ClientCode: clientCode,
        Key: key,
        referenceNo: referenceNo,
      };

      const res = await GetTransactionDetails(params);
      setData(res);
      console.log("GetTransactionDetails", res)
    } catch (err) {
      console.error(err);
    }
  };

  const booking = data?.booking || {};
  const passengers = data?.passengers || [];
  const payment = data?.payments?.[0] || {}; // ✅ FIX
  const fare = data?.fares?.[0] || {};
  const bookingPoints = data?.bookingPoints || {};

  const formatTime = (dateTime) => {
    if (!dateTime) return "";
    return new Date(dateTime).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDate = (dateTime) => {
    if (!dateTime) return "";
    return new Date(dateTime).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const paxCount = passengers.length || 1;

  const perPaxMarkup = (booking?.companyMarkUp || 0) / paxCount;

  const perPaxManagementFee = (booking?.managementFees || 0) / paxCount;
  const perPaxManagementFeeGST = (booking?.managementFeesGST || 0) / paxCount;

  //  Auto Print
  useEffect(() => {
    const timer = setTimeout(() => {
      window.print();
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
    {/* {loading && (
        <p class="text-center load"><span class="loader"></span></p>
      )} */}
      <div id="root">
        <div id="view-content" style={{ background: "white" }}>

          {/* Header */}
          <div className="header-bg">
            <div className="invoice_logo"></div>

            <div className="top_details">
              <p className="top_p right_txt">
                <strong>Invoice Date : </strong>
                {formatDate(booking?.createdOn)}{" "}
                <span className="color">
                  {formatTime(booking?.createdOn)}
                </span>
              </p>
            </div>
          </div>

          {/* Body */}
          <div className="invoice_body">

            {/* Agent Section */}
            <div className="agent_container">
              <h2 className="center_txt invoicenumber">
                {/* ✅ FIX */}
                <span>Invoice Number - {payment?.invoiceNo || booking?.referenceNo}</span>
              </h2>

              <div className="agent_details">

                {/* From */}
                <div className="agent_details-left">
                  <h3>From</h3>
                  <h4 className="captaize">BERRY JOURNEYS PRIVATE LIMITED</h4>
                  <p><strong>Regd Office :</strong> 2nd Floor, Plot no 3, IFFCO Tower, Sector 29</p>
                  <p>Gurugram, India -122007</p>
                  <p><strong>Email :</strong> finance@berryjourneys.com</p>
                  <p><strong>Phone :</strong> 9266601564</p>
                  <p><strong>State :</strong> Haryana</p>
                  <p><strong>GSTIN :</strong> 06AARCS6597A1ZX</p>
                  <p><strong>CIN :</strong> U93000UR2010PTC033270</p>
                </div>

                {/* To */}
                <div className="agent_details-right">
                  <h3>To</h3>
                  <h4 className="captaize">{data?.companyName || ""}</h4>
                  <p><strong>Address :</strong> {data?.address || ""}</p>
                  <p><strong>Email :</strong> {booking?.emailId || ""}</p>
                  <p><strong>Phone :</strong> {booking?.mobile || ""}</p>
                  <p><strong>State :</strong> {data?.state || ""}</p>
                  <p><strong>GST Number :</strong> {data?.gstNumber || ""}</p>
                </div>

              </div>
            </div>
            <div className="ticket_details-container">
              <table className="tkt_details-table invoice_table">
                <thead>
                  <tr>
                    <th>S No.</th>
                    <th>Reference No.</th>
                    <th>Policy No.</th>
                    {/* <th>Destination</th> */}
                    <th>Insurance Name</th>
                    <th>PAX Name</th>
                    <th>Travel Date</th>
                    <th>Policy Fare (Incl. Taxes)</th>
                    <th>Management Fee</th>
                    <th>Management Fee GST</th>
                  </tr>
                </thead>

                <tbody>
                  {passengers.map((p, index) => {
                    const finalBaseFare = (p.baseFare || 0) + (p.gst || 0) + perPaxMarkup;

                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{booking?.referenceNo}</td>
                        <td>{booking?.policyNumber || "-"}</td>
                        {/* <td>
                          {booking?.sourceName} - {booking?.destinationName}
                        </td> */}
                        <td>{booking?.insuranceName}</td>

                        <td>{`${p.title} ${p.firstName} ${p.lastName}`}</td>

                        <td>
                          {booking?.startDate}{"-"}
                          <span className="color">
                            {booking?.endDate}
                          </span>
                        </td>

                        {/* ✅ FIXED Base Fare */}
                        <td>₹ {booking.totalPremium.toFixed(2)}</td>

                        {/* ✅ Per Pax Fees */}
                        <td>₹ {perPaxManagementFee.toFixed(2)}</td>
                        <td>₹ {perPaxManagementFeeGST.toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Ticket Table */}


            {/* Billing */}
            <div className="bill_container">
              <div className="bill_details">

                <div className="bill_info">
                  <h3>GST Details :</h3>
                  <table className="bill_table">
                    <tbody>
                      <tr>
                        <th>Description</th>
                        <td>CGST @9%</td>
                        <td>SGST @9%</td>
                        <td>IGST 18%</td>
                      </tr>
                      <tr>
                        <th>Management Fee GST</th>
                        <td>0.00</td>
                        <td>0.00</td>
                        <td>0.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="bill_breakup">
                  <table className="bill_table invoice_table">
                    <thead>
                      <tr>
                        <th></th>
                        <th><strong>Gross:</strong></th>
                        {/* ✅ FIX */}
                        <th className="right_txt">
                          <strong>₹ {booking.totalPremium + booking.totalRiderAmount}</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td><strong>Total Amount</strong></td>
                        <td className="right_txt">
                          <strong>₹ {booking.companyAmount || 0}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

            {/* Terms */}
            <div className="footer-terms">
              <h3 className="address-head mt-4">
                Terms and Conditions E. & O.E :
              </h3>

              <ol>
                <li>Payment to be made as per contracted terms.</li>
                <li>All cheques must be A/c Payee Only.</li>
                <li>Interest @ 24% per annum on overdue bills.</li>
                <li>Check all details before using service.</li>
                <li>Refunds subject to approval.</li>
                <li>Subject to Haryana Jurisdiction.</li>
              </ol>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default InsPrintInvoice;